import type { TimePeriod } from '@carboncopyco/types';
import type { CapsuleDropdownItem } from '@carboncopyco/ui';
import { dateFormat } from '@carboncopyco/utils';

export const periodOptions: CapsuleDropdownItem<TimePeriod>[] = [
  {
    label: 'Last 7 days',
    id: '7',
  },
  {
    label: 'Last 30 days',
    id: '30',
  },
  {
    label: 'Last 60 days',
    id: '60',
  },
  { label: 'Last 90 days', id: '90' },
];

export const minimalChartOptions = {
  accessibility: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  title: {
    text: undefined,
  },
  legend: {
    enabled: false,
  },
  xAxis: {
    visible: false,
  },
  yAxis: {
    visible: false,
  },
};

export const baseTooltipOptions = {
  outside: true,
  backgroundColor: '#37363F',
  style: {
    opacity: 0.8,
    color: '#F9F9F9',
    shadow: '2px 4px 14 30',
    fontFamily: 'Inter',
  },
  borderRadius: 6,
  borderColor: '#37363F',
  useHTML: true,
  padding: 6,
  formatter: function () {
    const formattedDate = dateFormat(String(this.x), 'MMMM D');
    return `${formattedDate} <br /> <div class="flex items-center mt-0.5">${this.series.name}: <b class="ml-1">${this.y}</b> </div>`;
  },
};
